import { LGPlatformEnum } from './constant'
import { UA_PROTOCOLS, resolveUaLanguageKey, isUnityUA } from '@/packages/plugins/appUAConfig'

const getLocaleLanguage = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const languageKey = resolveUaLanguageKey(userAgent)?.toLowerCase()
  if (languageKey) {
    const language = userAgent.match(new RegExp(`(${languageKey})/([\\S.]+)`))
    if (language && language.length > 0) {
      const languageValue = language[language.length - 1]
      // 捕获段可能吞入后续 data 段，按任一协议 data key 截断
      const dataKey = UA_PROTOCOLS.map((protocol) => protocol.data.toLowerCase()).find((key) => languageValue.includes(key))
      if (dataKey) {
        const index = languageValue.indexOf(dataKey)
        return index !== -1 ? languageValue.substring(0, index) : 'en'
      } else {
        return languageValue
      }
    } else {
      return 'en'
    }
  } else if (isUnityUA(userAgent)) {
    const language = userAgent.match(/language:([^,]+)/)
    if (language && language.length > 0) {
      return language[language.length - 1]
    } else {
      return navigator.language.toLowerCase()
    }
  }
  return navigator.language.toLowerCase()
}

/**
 * @description: 语言SDK配置文件
 */
const config = {
  aliOssBaseURL: import.meta.env.VITE_LG_ALI_OSS_BASE_URL,
  aliOssAccBaseURL: import.meta.env.VITE_LG_ALI_OSS_ACC_BASE_URL,
  platform: LGPlatformEnum.META_EDITER,
  locale: getLocaleLanguage(),
  customLocale: {
    'zh-Hans': 'zh',
    'zh-Hant': 'zh'
  }
}

export default config
